import React from "react";
import TargetTypeNameField from "../TargetTypeNameField";

function MsbNameField({ msb, setMsb }) {
    const onChange = (value) => setMsb({ ...msb, name: value, baseMsb: false });

    return (
        <TargetTypeNameField
            value={msb.name}
            onValueChange={onChange}
            label="MSB Name"
        />
    );
}

export default MsbNameField;
